import { render, staticRenderFns } from "./FirstOwnStore.vue?vue&type=template&id=555c9fc8&scoped=true"
import script from "./FirstOwnStore.vue?vue&type=script&lang=js"
export * from "./FirstOwnStore.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "555c9fc8",
  null
  
)

export default component.exports